// Analytics utility for tracking conversions and user interactions

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    fbq: (...args: any[]) => void;
  }
}

export const trackEvent = (
  action: string,
  category: string,
  label?: string,
  value?: number
) => {
  // Google Analytics
  if (window.gtag) {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }

  // Facebook Pixel
  if (window.fbq) {
    window.fbq("track", "CustomEvent", {
      event_name: action,
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

export const trackPageView = (pageTitle: string, pageLocation: string) => {
  if (window.gtag) {
    window.gtag("config", "GA_MEASUREMENT_ID", {
      page_title: pageTitle,
      page_location: pageLocation,
    });
  }

  if (window.fbq) {
    window.fbq("track", "PageView");
  }
};

export const trackPlanClick = (planName: string, planPrice: number) => {
  trackEvent("plan_click", "pricing", planName, planPrice);
};

export const trackWhatsAppClick = (planName: string) => {
  trackEvent("whatsapp_click", "conversion", planName);
};

export const trackSignUpClick = (source: string) => {
  trackEvent("signup_click", "conversion", source);
};

export const trackLoginClick = (source: string) => {
  trackEvent("login_click", "engagement", source);
};

export const trackScrollToPricing = () => {
  trackEvent("scroll_to_pricing", "engagement", "cta_button");
};

export const trackFeatureView = (featureName: string) => {
  trackEvent("feature_view", "engagement", featureName);
};

export const trackFAQView = (question: string) => {
  trackEvent("faq_view", "engagement", question);
};

export const trackConversion = (conversionType: string, value?: number) => {
  trackEvent("conversion", "conversion", conversionType, value);

  if (window.fbq) {
    window.fbq("track", "Lead", {
      value: value,
      currency: "BRL",
    });
  }
};

export const trackSocialClick = (platform: string) => {
  trackEvent("social_click", "engagement", platform);
};

export const trackLoadTime = (loadTime: number) => {
  trackEvent("page_load_time", "performance", "landing_page", loadTime);
};
